import React, { Fragment } from "react";
import { Button, Image, Table } from "react-bootstrap";
import moment from "moment";
function Approved(props) {
  return (
    <Fragment>
      <div>
        <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
          <Table className="HideShowTable enMinWidth900">
            <thead>
              <tr className="super_admin_all_users_table_head">
                <th style={{ width: "10%" }} className="f12-700">
                  Transaction
                  <br />
                  ID
                </th>
                <th style={{ width: "15%" }} className="f12-700">
                  User Name
                </th>
                <th style={{ width: "18%" }} className="f12-700">
                  Transaction
                  <br />
                  Type
                </th>
                {/* <th style={{ width: "15%" }} className="f12-700">
                            Payment To
                          </th> */}
                <th style={{ width: "12%" }} className="f12-700">
                  Date & Time
                </th>
                <th style={{ width: "11%" }} className="f12-700">
                  Amount
                </th>
                <th style={{ width: "10%" }} className="f12-700">
                  Available
                  <br />
                  Amount
                </th>
                <th style={{ width: "14%" }} className="f12-700">
                  Status
                </th>
                {/* <th style={{ width: "10%" }} className="f12-700">
                  Action
                </th> */}
              </tr>
            </thead>

            {props.filteredData.map((transaction, index) => (
              <Fragment key={index}>
                {transaction && transaction.status === "COMPLETED" ? (
                  <tbody>
                    <tr className="super_admin_all_users_table_body">
                      <td style={{ width: "10%" }}>
                        <div className="f12-400 text-break">
                          {transaction && transaction._id}
                        </div>
                      </td>
                      <td style={{ width: "15%" }}>
                        <div className="d-flex align-items-center">
                          <div className="enIMG33 rounded-circle mr-3">
                            <Image
                              fluid
                              src={require("../../../../assets/images/ActionImages/demoprofile.jpg")}
                              alt="Icon"
                            />
                          </div>
                          <div className="f12-400">
                            {transaction &&
                              transaction.user_id &&
                              transaction.user_id.first_name}
                          </div>
                        </div>
                      </td>
                      <td style={{ width: "18%" }}>
                        <div className="f12-400 d-flex align-items-center">
                          {/* <Image
                            src={require("../../../../assets/images/UserManagement/plusRound.svg")}
                            alt="Plus"
                            title="Plus"
                            fluid
                            className="w-20px mr-2"
                          /> */}
                          Settled
                        </div>
                        {/* <div className="f12-400 d-flex align-items-center">
                          <Image
                            src={require("../../../../assets/images/UserManagement/minusRound.svg")}
                            alt="Plus"
                            title="Plus"
                            fluid
                            className="w-20px mr-2"
                          />
                          Withdraw
                        </div> */}
                      </td>
                      {/* <td style={{ width: "15%" }}>
                                <div className="d-flex align-items-center">
                                  <div className="enIMG33 rounded-circle mr-3">
                                    <Image
                                      fluid
                                      src={require("../../../../assets/images/ActionImages/demoprofile.jpg")}
                                      alt="Icon"
                                    />
                                  </div>
                                  <div className="f12-400">Steve Yeun</div>
                                </div>
                              </td> */}
                      <td style={{ width: "12%" }}>
                        <div className="f12-400">
                          {moment(transaction && transaction.createdAt).format(
                            "Do MMMM ,YYYY"
                          )}
                          <br />
                          {moment(transaction && transaction.createdAt).format(
                            "LT"
                          )}
                        </div>
                      </td>
                      <td style={{ width: "11%" }}>
                        <div className="f12-400">
                          ₹ {transaction && transaction.balance}
                        </div>
                      </td>
                      <td style={{ width: "10%" }}>
                        <div className="f12-400">
                          ₹{" "}
                          {transaction &&
                            transaction.wallet_id &&
                            transaction.wallet_id.balance &&
                            parseFloat(transaction.wallet_id.balance).toFixed(
                              2
                            )}
                        </div>
                      </td>
                      <td style={{ width: "14%" }}>
                        {/* <div className="enPendingLBL">Pending</div> */}
                        <div className="enSuccessLBL">
                          {transaction && transaction.status === "COMPLETED"
                            ? "Success"
                            : transaction && transaction.status === "PENDING"
                            ? "Pending"
                            : "Rejected"}
                        </div>
                        {/* <div className="enCancelledLBL">Rejected</div> */}
                      </td>
                      {/* <td style={{ width: "10%" }}>
                          <div className="d-flex align-items-center">
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              onClick={props.handleShowReject}
                            >
                              <Image
                                src={require("../../../../assets/images/UserManagement/reject.svg")}
                                alt="View"
                                title="View"
                                width="16px"
                                fluid
                              />
                            </Button>
                            <Button
                              variant="link"
                              className="enIconBtn"
                              onClick={props.handleShowAccept}
                            >
                              <Image
                                src={require("../../../../assets/images/UserManagement/verified.svg")}
                                alt="View"
                                title="View"
                                width="16px"
                                fluid
                              />
                            </Button>
                          </div>
                        </td> */}
                    </tr>
                  </tbody>
                ) : (
                  <> </>
                )}
              </Fragment>
            ))}
          </Table>
        </div>
      </div>
    </Fragment>
  );
}

export default Approved;

// import React from "react";
// import { Button, Image, Table } from "react-bootstrap";

// function Approved(props) {
//   return (
//     <div>
//       <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
//         <Table className="HideShowTable enMinWidth900">
//           <thead>
//             <tr className="super_admin_all_users_table_head">
//               <th style={{ width: "20%" }} className="f12-700">
//                 Account Holder`s
//                 <br />
//                 Name
//               </th>
//               <th style={{ width: "15%" }} className="f12-700">
//                 Bank <br /> Name
//               </th>
//               <th style={{ width: "20%" }} className="f12-700">
//                 Account
//                 <br />
//                 Number
//               </th>
//               <th style={{ width: "15%" }} className="f12-700">
//                 Account <br /> Type
//               </th>
//               <th style={{ width: "15%" }} className="f12-700">
//                 IFSC Code
//               </th>
//               <th style={{ width: "15%" }} className="f12-700">
//                 Remittance
//                 <br />
//                 Status
//               </th>
//             </tr>
//           </thead>
//           {props.filteredData
//             .slice(props.start, props.end)
//             .map((transaction, index) => (
//               <tbody key={index}>
//                 <tr className="super_admin_all_users_table_body">
//                   <td style={{ width: "20%" }}>
//                     <div className="d-flex align-items-center">
//                       <div className="enIMG33 rounded-circle mr-3">
//                         <Image
//                           fluid
//                           src={require("../../../../assets/images/ActionImages/demoprofile.jpg")}
//                           alt="Icon"
//                         />
//                       </div>
//                       <div className="f12-400">
//                         {transaction &&
//                           transaction.user_id &&
//                           transaction.user_id.first_name}
//                       </div>
//                     </div>
//                   </td>
//                   <td style={{ width: "15%" }}>
//                     <div className="f12-400 text-break">Kotak bank</div>
//                   </td>
//                   <td style={{ width: "20%" }}>
//                     <div className="f12-400 d-flex align-items-center">
//                       XXXXXXXXXX1234
//                     </div>
//                   </td>

//                   <td style={{ width: "15%" }}>
//                     <div className="f12-400">Savings</div>
//                   </td>
//                   <td style={{ width: "15%" }}>
//                     <div className="f12-400">KKBK00000012</div>
//                   </td>
//                   <td style={{ width: "15%" }}>
//                     <div className="f12-400 badge badge-warning p-1">
//                       Unsettled
//                     </div>
//                   </td>
//                 </tr>
//               </tbody>
//             ))}
//         </Table>
//       </div>
//     </div>
//   );
// }

// export default Approved;
